import { initialDaNotificationsState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { DaNotificationsConstants } from "constants/constants";
import { DaNotificationsState } from "types/DaNotifications";

export const daNotificationsReducer = (
  state = initialDaNotificationsState,
  action: ReducersInterfaceAction,
): DaNotificationsState => {
  switch (action.type) {
    case DaNotificationsConstants.DA_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loadingData: false,
        notificationsList: action.payload,
      };
    case DaNotificationsConstants.DA_NOTIFICATIONS_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case DaNotificationsConstants.DA_NOTIFICATIONS_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case DaNotificationsConstants.DA_NOTIFICATIONS_DRAWER_STATE:
      return {
        ...state,
        isDrawerOpen: action.payload,
      };
    default:
      return state;
  }
};
